import React from "react";
import { useForm } from "react-hook-form";
import { updateDb } from "../services/updateDb";

import { useNavigate, useSearchParams } from "react-router-dom";
import useAxiosFetch from "../common/useAxiosFetch";

import LoadPage from "../common/LoadPage";
import ProjectForm from "./ProjectForm";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const EditProjectPage = () => {
  const { t } = useTranslation();
  const { triggerHeaderRefresh } = useAppContext();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");

  const { data, loading } = useAxiosFetch("/api/projects/" + projectId);
  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm();

  const onSubmit = async (data) => {
    let projObj = {
      name: data.name,
      orgId: data.orgId,
      ownerUserId: data.ownerUserId,
    };

    const res = await updateDb("/api/projects/update/" + projectId, projObj);

    if (res.success) {
      triggerHeaderRefresh();
      navigate("/projects", { state: { message: t('domain') + " " + t('updated'), type: "warning" } });
    }
  };

  if (loading) {
    return <LoadPage />;
  } else if (data.name) {
    setValue("name", data.name);
    setValue("orgId", data.orgId);
    setValue("ownerUserId", data.ownerUserId);

    return (
      <div id="content">
        <div id="content-title">{t('edit_domain')}</div>

        <div className="content-bubble">

          <ProjectForm
            register={register}
            handleSubmit={handleSubmit}            
            onSubmit={onSubmit}
            text={t('edit_domain')}
          />
        </div>
      </div>
    );
  }
};

export default EditProjectPage;
